import { render } from "./Drawer.vue?vue&type=template&id=8584ba52&scoped=true"
import script from "./Drawer.vue?vue&type=script&lang=js"
export * from "./Drawer.vue?vue&type=script&lang=js"

import "./Drawer.vue?vue&type=style&index=0&id=8584ba52&lang=less&scoped=true"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8584ba52"]])

export default __exports__